// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class SelectCapitalIncreaseMethodView extends JQueryView {
  isProfessionalPlan: boolean;

  constructor(isProfessionalPlan: boolean) {
    super('.full-screen-form-page');

    this.isProfessionalPlan = isProfessionalPlan;
  }

  @on({ event: 'click', selector: '#not-establish' })
  onClickNotEstablish() {
    $('#not-establish').addClass('active');
    $('#establish').removeClass('active');
    $('#submit-button').attr(
      'href',
      '/company/capital_increase_rounds/confirmation',
    );
    $('#submit-button').removeClass('disabled');
    this.removeModalDateAttr();
  }

  @on({ event: 'click', selector: '#establish' })
  onClickEstablish() {
    $('#establish').addClass('active');
    $('#not-establish').removeClass('active');
    $('#submit-button').attr(
      'href',
      '/company/procedures/capital_increases/new',
    );
    $('#submit-button').removeClass('disabled');
    this.addModalDateAttr();
  }

  addModalDateAttr() {
    if (!this.isProfessionalPlan) {
      $('#submit-button').attr('data-toggle', 'modal');
      $('#submit-button').attr('data-target', '#plan_modal');
    }
  }

  removeModalDateAttr() {
    if ($('#submit-button').is('[data-toggle]')) {
      $('#submit-button').removeAttr('data-toggle', 'modal');
      $('#submit-button').removeAttr('data-target', '#plan_modal');
    }
  }
}
